<template>
  <div>
    <Button
      :size="15"
      color="#28a745"
      colorText="#ffffff"
      tooltip="Importar"
      icon="fas fa-plus"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      traslate
      title="Agregar sección"
      @click.native="openModal('modal')"
    />

    <ui-modal ref="modal" size="large" title="Agregar nueva sección">
      <!-- row 1 -->
      <div class="d-flex">
        <ui-textbox
          floating-label
          label="Nombre"
          v-model="formulario.nombreModel"
          class="w-50 mr-3"
        />

        <ui-textbox
          floating-label
          label="Referencia"
          v-model="formulario.referenciaModel"
          class="w-50"
        />
      </div>

      <!-- row 1 -->
      <div class="d-flex">
        <ui-select
          class="w-100"
          has-search
          label="Módulo"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="listaModulos"
          v-model="formulario.moduloModel"
        />
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-primary" @click="validarFormulario">
          Guardar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";

// Buttom
import Button from "../../../common/Button";

// Constantes
import {
  saveSeccion,
  getSecciones,
} from "../../../../constants/superadministrador";

export default {
  props: ["listaSecciones", "listaModulos"],
  data() {
    return {
      formulario: {
        nombreModel: "",
        referenciaModel: "",
        moduloModel: [],
      },
    };
  },
  components: {
    UiModal,
    UiTextbox,
    UiSelect,
    Button,
  },

  methods: {
    ...mapActions("superadministrador", ["actionSetDataSecciones"]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    validarFormulario() {
      if (
        this.formulario.nombreModel != "" ||
        this.formulario.referenciaModel != "" ||
        this.formulario.moduloModel != ""
      ) {
        this.guardar();
      } else {
        this.$vToastify.error("Campos sin completar", "¡Error!");
      }
    },
    async guardar() {
      let sql = await saveSeccion(this.formulario);

      if (!sql.error) {
        // Toast proceso exitoso
        this.$vToastify.success("Sección creada con éxito", "¡Realizado");

        // Limpiar variables
        this.formulario.nombreModel = "";
        this.formulario.referenciaModel = "";
        this.formulario.moduloModel = "";

        let dataSeccionesDB = await getSecciones();
        this.data = dataSeccionesDB;

        this.actionSetDataSecciones(dataSeccionesDB.data_table);

        // Cerrar Modal
        this.closeModal("modal");
      } else {
        if (sql.data.length > 0) {
          // Errores de validación
          sql.data.map((item) => {
            this.$vToastify.error(`${item}`);
          });
        } else {
          // Proceso erroneo
          this.$vToastify.error("La Sección no pudo ser creada", "¡Error!");
        }
      }
    },
  },
};
</script>

<style></style>
